import { render, staticRenderFns } from "./RegisterMedication.vue?vue&type=template&id=92d1527e&scoped=true"
import script from "./RegisterMedication.vue?vue&type=script&lang=js"
export * from "./RegisterMedication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d1527e",
  null
  
)

export default component.exports